<template>
	<svg viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
		<line x1="24.3094" y1="4.37114e-08" x2="24.3094" y2="72" :stroke="col" :stroke-width="strokeWidth"/>
		<line x1="49.6907" y1="4.37114e-08" x2="49.6907" y2="72" :stroke="col" :stroke-width="strokeWidth"/>
		<line y1="47.6906" x2="72" y2="47.6906" :stroke="col" :stroke-width="strokeWidth"/>
		<line y1="22.3093" x2="72" y2="22.3093" :stroke="col" :stroke-width="strokeWidth"/>
	</svg>
</template>

<script>

export default {
  name: 'BaseHash',
  data () {
    return {
    }
  },
  props: ['color', 'width'],
  computed: {
    col () {
      if (this.color) {
        return this.color
      } else {
        return 'black'
      }
    },
    strokeWidth () {
      if (this.width) {
        return this.width
      } else {
        return 2
      }
    }
  }
}
</script>

<style lang="stylus">
  .inline-hash
    @apply w-4 h-4 inline mr-1
    margin-bottom: 0.25rem
</style>
